import EnhancedTab from 'lib/designSystem/TabSimulation';
import React from 'react';

import SignDocuments from './Components/Documents';
import Portfolios from './Components/Portfolios';
import Signers from './Components/Signers';

const Contracts = () => {
  const tabs = [
    {
      label: 'Documentos',
      component: <SignDocuments />,
      path: 'documents',
    },
    {
      label: 'Portafolios',
      component: <Portfolios />,
      path: 'portfolios',
    },
    {
      label: 'Representantes legales',
      component: <Signers />,
      path: 'signers',
    },
  ];

  return (
    <EnhancedTab
      tabType="secondary"
      startValue={0}
      tabs={tabs}
      onTabChange={() => {}}
    />
  );
};

export default Contracts;
